import styles from "./Glitch.module.scss";

const GlitchText = ({ children, small=false }) => {
	return (
		<h3 className={`${styles.glitchText} ${small ? styles.small : ""} uppercase`}>
			<span aria-hidden="true">{children}</span>
			{children}
			<span aria-hidden="true">{children}</span>
		</h3>
	);
};

const GlitchImage = ({ image, alt, className }) => {
	return (
		<div className={`${styles.glitchImage} ${className}`}>
			<span aria-hidden="true">
				<img src={image} alt={alt} />
			</span>
			<img src={image} alt={alt} />
			<span aria-hidden="true">
				<img src={image} alt={alt} />
			</span>
		</div>
	);
};

export { GlitchText, GlitchImage };
